import { TCreativeGoal, TCreativeGoalResponse } from "domain/entities/creative-goal-response";
import { numberWithCommas } from "helper/cardsHelper";

const KPI = {
  conversion: 'Conversion',
  conversionRate: 'Conversion rate',
  visitors: 'Unique visitors',
  time: 'Time on creative',
}

const getValue = (kpi: string, goalValue: string) : string => {
  if (kpi === (KPI.conversion || KPI.visitors)) {
    return numberWithCommas(goalValue);
  }

  if (kpi === KPI.conversionRate) {
    return `${Number(goalValue).toFixed(0)}%`
  }

  return goalValue;
}

export class CreativeGoalModel {
  static from(
    creativeGoalResponse: TCreativeGoalResponse
  ): TCreativeGoal {
    return {
      cards: creativeGoalResponse.cards,
      creativeGoals: {
        dataColumns: [
          {
            header: "Key Performance Indicator",
            accessor: "keyPerformanceIndicator",
          },
          {
            header: "Current value",
            accessor: "currentValue",
          },
          {
            header: "Goal value",
            accessor: "goalValue",
          },

          {
            header: "Completion",
            accessor: "completion",
          },
        ],
        dataRows: creativeGoalResponse.creativeGoals.map(
          (goal) => {
            return {
              keyPerformanceIndicator: goal.keyPerformanceIndicator,
              currentValue: getValue(goal.keyPerformanceIndicator, goal.currentValue),
              goalValue: getValue(goal.keyPerformanceIndicator, goal.goalValue),
              completion: goal.completion
            };
          }
        ),
      },
    };
  }
}